namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailDenikSsl extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GDenikSslReadDto;
        private newRecord: boolean;
        private detailObj: DetailDenikSslObj & GContent;
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailDenikSslObj());
            this.detailObj.createBase({
                contentName: "detailDenikSsl",
                contentCaption: "jres:29808057",
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailDenikSsl", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailDenikSslObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GDenikSslReadDto> {
        nazev: string;

        create() {

        }

        textPopis(): string | undefined | null {
            return this.data["nazev"]
        }

        setSxsDetail(): string {
            return (this.data.sslden) ? this.data.sslden.toString() : "";
        }

        saveData(data: Gordic.AdmIsl.Interface.GDenikSslDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            (this.cnt.isl.DenikSsl.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    Gordic.Data.readerCache.clearCache("Gordic.ControlsLogic.Client.GReaderSslsden")
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    })
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailDenikSsl", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.DenikSsl.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1}".format(this.options.contentCaption, (this.data.nazev) ? this.data.nazev : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" },
                {
                    favorite: true,
                    type: "static",
                    visible: this.options.newRecord == false,
                    caption: "jres:33000138",
                    icon: "fa-link",
                    children: [
                        { action: this.cnt.actions.actOpenRokyPodacihoDeniku },
                        { action: this.cnt.actions.actOpenAdmDenikSslStupenUtajeni },
                        { action: this.cnt.actions.actOpenDenikSslSpisovyUzel },
                        { action: this.cnt.actions.actOpenAdmDenikSslStrediskoSpisovychUzlu },
                        { action: this.cnt.actions.actOpenFunkcniMistoDenikSsl },
                        { action: this.cnt.actions.actOpenOrganizacniJednotkaDenikSsl }
                    ]
                }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actOpenRokyPodacihoDeniku: {
                    caption: "jres:33000612",
                    icon: "fa-link",
                    run: () => {
                        this.openRokyPodacihoDeniku();
                    }
                },
                actOpenDenikSslSpisovyUzel: {
                    caption: "jres:33000614",
                    icon: "fa-link",
                    run: () => {
                        this.openDenikSslSpisovyUzel();
                    }
                },
                actOpenFunkcniMistoDenikSsl: {
                    caption: "jres:33000622",
                    icon: "fa-link",
                    run: () => {
                        this.openFunkcniMistoDenikSsl();
                    }
                },
                actOpenOrganizacniJednotkaDenikSsl: {
                    caption: "jres:33000619", //RC 33000619 : Střediska navázaná na deník
                    icon: "fa-link",
                    run: () => {
                        this.openDenikSslOrganizacniStredisko();
                    }
                },
                actOpenAdmDenikSslStrediskoSpisovychUzlu: {
                    caption: "jres:33000624".format(this.nazev), //RC 33000619 : Střediska navázaná na deník
                    icon: "fa-link",
                    run: () => {
                        this.openAdmDenikSslStrediskoSpisovychUzlu();
                    }
                },
                actOpenAdmDenikSslStupenUtajeni: {
                    caption: "jres:33000629", //RC 33000629 : Povolené stupně utajení pro deník
                    enabled: this.data.priz_stu == 1,
                    icon: "fa-link",
                    run: () => {
                        this.openAdmDenikSslStupenUtajeni();
                    }
                },
            }
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            this.form.form.layoutDescriptor = "L2M2S1";
            this.MakeSection("");
            this.MakeSelectField("ico", Gordic.Prefabs.Select.ekosico(), { model: "model.ico=value.ico" })  // JKLUSACEK - cizí klíč je do ekosico
            this.MakeField("sslden", { validators: [new Gordic.Validators.Length({ max: 6, min: 1 })] })
            this.MakeField("zkratka", { flag: this.createFlagNemenne() })
            this.MakeField("nazev")
            this.MakeField("poznamka")
            this.MakeField("rok_akt", { emptyValue: null })
            this.MakeSelectField("priz_den_cj", Gordic.Prefabs.Select.sslcpdc(), { model: "model.priz_den_cj=value.priz_den_cj, model.priz_den_cj_txt=value.priz_den_cj_txt", flag: this.createFlagNemenne() })
            this.MakeSelectField("typ_den", Gordic.Prefabs.Select.sslctyd(), { model: "model.typ_den=value.typ_den, model.typ_den_txt=value.typ_den_txt", flag: this.createFlagNemenne() })
            this.MakeSelectField("priz_stu", Gordic.Prefabs.Select.gincpan(), { model: "model.priz_stu=value.priz_an" })
            this.MakeSelectField("priz_uzav", Gordic.Prefabs.Select.sslcpuz(), { model: "model.priz_uzav=value.priz_uzav", flag: this.createFlagNemenne() })
            this.MakeSelectField("priz_den_ts", Gordic.Prefabs.Select.sslcpdt(), { model: "model.priz_den_ts=value.priz_den_ts", flag: this.createFlagNemenne() })
            this.MakeSelectField("rezim_nakl", Gordic.Prefabs.Select.admGincren(), { model: "model.rezim_nakl=value.rezim_nakl" })
            this.MakeSection("");
            this.MakeField("format_cj")
            this.MakeField("format_cj_pis")
            this.MakeField("format_cj_ext")
            this.MakeField("format_spz")
            this.MakeField("sslden1")
            this.MakeField("sslden2")
            this.MakeField("sslden3")
            this.MakeField("sslden4")
            this.MakeField("dat_od")
            this.MakeField("dat_do")
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt())
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" })
            this.MakeField("dat_zmena");
        }

        private openRokyPodacihoDeniku() {
            this.cnt.navigate("Gordic.Adm.WebControls.SeznamAdmRokDenikuSsl", { sslden: this.data.sslden })
        }

        private openDenikSslSpisovyUzel() {
            this.cnt.navigate("Gordic.Adm.WebControls.SeznamAdmDenikSslSpisovyUzel", { sslden: this.data.sslden })
        }

        private openFunkcniMistoDenikSsl() {
            this.cnt.navigate("Gordic.Adm.WebControls.SeznamAdmFunkcniMistoDenikSsl", { sslden: this.data.sslden })
        }

        private openDenikSslOrganizacniStredisko() {
            this.cnt.navigate("Gordic.Adm.WebControls.SeznamOrganizacniJednotkaDenikSsl", { sslden: this.data.sslden })
        }

        private openAdmDenikSslStrediskoSpisovychUzlu() {
            this.cnt.navigate("Gordic.Adm.WebControls.SeznamAdmDenikSslStrediskoSpisovychUzlu", { sslden: this.data.sslden })
        }

        private openAdmDenikSslStupenUtajeni() {
            this.cnt.navigate("Gordic.Adm.WebControls.SeznamAdmDenikSslStupenUtajeni", { sslden: this.data.sslden })
        }
    }
}
